import React, {Component} from 'react'
import NavLink from '../Component/NavLink'
import {Link} from 'react-router'

import Logo from '../images/jeyutech-logo.png'
import Icons from '../images/social-media-icon.png'

const Jeyu = {
  footerBG: {
    background: '#014852'
  },
  nav: {
    color: '#548e96',
    margin: '16px 16px 0 2px',
    display: 'inline-block',
    fontSize: 13
  },
  jeyu: {
    color: '#548e96',
    minWidth: 200,
    display: 'inline-block'
  },
  p: {
    color: '#548e96',
    fontSize: 12,
    fontWeight: 100,
    paddingTop: 6
  },
  logo: {
    background: 'url('+Logo+')',
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    width: 225,
    height: 42,
    marginTop: 5,
    marginRight: 5,
    display:'inline-block'
  },
  icon1: {
    backgroundImage: 'url('+Icons+')',
    backgroundSize: 'inherit',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0px 0px',
    width: 35,
    height: 35,
    display: 'inline-block',
    margin: '0 0 0 5px'
  },
  icon2: {
    backgroundImage: 'url('+Icons+')',
    backgroundSize: 'inherit',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '-42px 0px',
    width: 35,
    height: 35,
    display: 'inline-block',
    margin: '0 0 0 2px'
  },
  icon3: {
    backgroundImage: 'url('+Icons+')',
    backgroundSize: 'inherit',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '-85px 0px',
    width: 35,
    height: 35,
    display: 'inline-block',
    margin: '0 0 0 2px'
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  }
}

export default class Footer extends Component {

  render() {
    return(
      <div className="container-fluid" style={Jeyu.footerBG}>
       <div className="row">
         <div className="container">
          <div className="row">
           <div className="xs-12 sm-12 md-12 lg-4">
           <div style={Jeyu.flex}>
            <div style={Jeyu.logo}></div>
             <a href="#" style={Jeyu.icon1} className="footerIcon1"></a>
             <a href="#" style={Jeyu.icon2} className="footerIcon2"></a>
             <a href="https://www.youtube.com/channel/UCbsoSU3Hag3-615Px4kxepg" target="_blank" style={Jeyu.icon3} className="footerIcon3"></a>
            </div>
           </div>
           <div className="xs-12 sm-12 md-12 lg-4">
             <NavLink to="/" style={Jeyu.nav} className="footerLink">關於我們</NavLink>
             <NavLink to="/KnowledgeBase" style={Jeyu.nav} className="footerLink">知識庫</NavLink>
             <NavLink to="/Dealer" style={Jeyu.nav} className="footerLink">成為經銷商</NavLink>
             <NavLink to="/Contact" style={Jeyu.nav} className="footerLink">聯絡我們</NavLink>
           </div>
           <div className="xs-12 sm-12 md-12 lg-4">
            <p style={Jeyu.p}>版權所有 翻印必究  Copyright &copy; 2017 <Link to="/" style={Jeyu.p} className="footerLink">傑宇特科技有限公司</Link></p>
           </div>
          </div>
         </div>
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layout/Footer.js